













































import { Component, Vue } from 'vue-property-decorator';
import { getCommodityWorker } from '@/utils/api';
import DialogImport from './dialogImport.vue';
import empty from '@/components/empty/empty.vue';
import tableEmpty from '@/components/empty/tableEmpty.vue';

//表单数据类型限定
interface RuleForm {
  page: number;
  size: number;
}

@Component({
  components: { DialogImport, empty, tableEmpty },
})
export default class goodsImport extends Vue {
  $refs: any;
  activeName: string = '0'; //当前激活的tab
  tableData: any = []; // 表格数据
  ruleForm: RuleForm = {
    //接口入参
    page: 1,
    size: 10,
  };
  total: number = 0; //总数量
  dialogShow: boolean = false; //开始导入商品弹窗是否显示
  $message: any;
  timer: number = 0; //定时器
  statusList = {
    //状态值对应表
    '0': '文件上传成功',
    '1': '文件上传失败',
    '10': '文件数据校验中',
    '11': '文件数据校验通过',
    '12': '文件数据校验不通过',
    '13': '文件数据校验异常',
    '20': '数据导入中',
    '21': '数据部分导入成功',
    '22': '数据导入成功',
    '23': '数据导入失败',
    '24': '数据导入异常',
  };
  successState: Array<number> = [0, 11, 22]; //成功状态显示
  partSuccessState: Array<number> = [21]; //部分成功状态显示
  failState: Array<number> = [1, 12, 13, 23, 24]; //失败异常显示
  downloadFailState: Array<number> = [12, 21, 23]; //下载失败文件的状态
  showFailMessageState: Array<number> = [13, 24]; //显示错误message的状态
  created() {
    this.update();
  }

  /**
    更新导入进度
   */
  update() {
    let params: RuleForm = { ...this.ruleForm };
    --params.page;
    getCommodityWorker(Object.assign(params))
      .then((res: any) => {
        this.tableData = res.content;
        this.total = res.totalElements;
        this.ruleForm.page = res.number + 1;
        if (!this.checkIsLoaded()) {
          setTimeout(() => {
            this.update();
          }, 2000);
        }
      })
      .catch((error) => {
        console.error(error);
        this.$message.error(error);
      });
  }

  /**
    检测是否加载完毕
    @params
   */
  checkIsLoaded() {
    const finishStates: Array<number> = [1, 12, 13, 21, 22, 23, 24];
    let loadedNum: number = 0;
    for (let item of this.tableData) {
      if (finishStates.includes(item.state)) {
        loadedNum++;
      }
    }
    return loadedNum === this.tableData.length;
  }

  /**
    下载失败原因
    @params row 当前行数据
   */
  download(row) {
    if (!row.failUrl) {
      this.$message.warning('暂无可以下载的文件');
      return;
    }
    let a: HTMLAnchorElement = document.createElement('a');
    a.href = row.failUrl;
    a.click();
  }

  /**
    开始导入商品
    @params
   */
  importGoods() {
    this.dialogShow = true;
    clearInterval(this.timer);
  }

  /**
    接收关闭弹窗事件
    @params
   */
  onClose() {
    this.dialogShow = false;
  }

  /**
    确认开始导入
    @params
   */
  onConfirm() {
    this.dialogShow = false;
    this.update();
  }

  /**
    当前页码切换
    @params val 切换后的页码值
   */
  handleCurrentChange(val) {
    this.ruleForm.page = val;
    this.update();
  }

  /**
    一页数量切换
    @params val 切换后的一页数量
   */
  handleSizeChange(val) {
    this.ruleForm.size = val;
    this.ruleForm.page = 1;
    this.update();
  }

  beforedestroy() {
    clearInterval(this.timer);
  }
}
